import React, { FC, useState } from "react";
import Modal from "ui/Modal/Modal";
import { useStore } from "store";

import Upper, { Step } from "./components/Upper/Upper";
import EmailForm from "./components/EmailForm/EmailForm";
import SMSForm from "./components/SMSForm/SMSForm";

import styles from "./ProductArrivalModal.module.scss";

type Props = {
  productId: Entity.Product["id"];
  onClose: () => void;
};

const ProductArrivalModal: FC<Props> = ({ productId, onClose }: Props) => {
  const { notifications } = useStore();
  const [step, setStep] = useState<Step>("email");

  const onCloseModal = () => {
    onClose && onClose();
    notifications.show({
      type: "toast",
      props: { title: "Подписка на уведомление оформлена" },
    });
  };

  const Component = step === "email" ? EmailForm : SMSForm;

  return (
    <div className={styles.productArrival}>
      <Modal
        classNameWrapper={styles.productArrivalModalWrapper}
        classNameBody={styles.productArrivalModalBody}
        onClose={onClose}
      >
        <Upper onStepChange={setStep} activeStep={step} />

        <Component productId={productId} onClose={onCloseModal} />
      </Modal>
    </div>
  );
};

export default ProductArrivalModal;
